import { createSelector } from 'reselect';
import { compose, reject, get } from 'lodash/fp';
import { getStringArrayProp, getStringProp, values } from '@mews/fp';
import { globalizationSelector as moduleSelector } from '@mews/globalization';
import { getNowUtc, createOptionsSelector, getOrEmptyObject } from '@mews-commander/utils';
import { LegalEnvironment } from '@mews-commander/types';

export const getLegalEnvironments = compose(getOrEmptyObject('legalEnvironments'), moduleSelector);

const getValidLegalEnvironments = createSelector(getLegalEnvironments, getNowUtc, (legalEnvironments, nowUtc) =>
    reject(({ validityStartUtc, validityEndUtc }) => {
        if (!!validityStartUtc && validityStartUtc > nowUtc) {
            return true;
        } else if (!!validityEndUtc && validityEndUtc < nowUtc) {
            return true;
        }
        return false;
    })(legalEnvironments)
);

export const getLegalEnvironmentOptions = createOptionsSelector(getValidLegalEnvironments, {
    value: 'code',
    label: 'englishName',
});

export const getLegalEnvironment = createSelector(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    getStringProp('legalEnvironmentCode'),
    getLegalEnvironments,
    getOrEmptyObject
);

export const getLegalEnvironmentsArray = createSelector(
    getStringArrayProp('legalEnvironmentCodes'),
    getLegalEnvironments,
    (legalEnvironments, legalEnvironmentCodes) => {
        const legalEnvironmentList: LegalEnvironment[] = values(legalEnvironmentCodes);

        return legalEnvironmentList.filter(({ code }) => legalEnvironments.includes(code));
    }
);

export const getLegalEnvironmentCountryCode = compose(get('countryCode'), getLegalEnvironment);
